export const COLORS = {
  primary: "#F0AF42",
  nutrition: "#AECE38",
  rewardRed: "#E06226",
  movementPink: "#E48BA4",
  mentalGreen: "#209092",
  marketGray: "#bbbbbb",
  textGray: "#5A6A80",
  staticGray: " #555a60",
  white: "#fff",
  black: "#000",
  lightGray: "#D9D9D9",
  darkGray: "#54595F",
  gray50: "#f9fafb",
  slate200: "#e2e8f0",
};
